import React from 'react';
import { createBreakpoints, Picture } from '../../../Picture/Picture';
import { WidgetFeature } from '../Widget';
import { ImageMime } from '../../../../../utils/imageTypes';

const IMAGE_SIZE = {
  width: 712,
  height: 512,
};

const BREAKPOINTS_CONFIG = [
  {
    maxScreenWidth: 1365,
    imageWidth: 320,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1919,
    imageWidth: 344,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 2560,
    imageWidth: 406,
    densityList: [1, 2],
  },
];

const WIDGET_IMAGE_FILTERS = 'q_100';
const WIDGET_IMAGE_TYPES: ImageMime[] = [ImageMime.WEBP, ImageMime.PNG];

const BREAKPOINTS = createBreakpoints(BREAKPOINTS_CONFIG, IMAGE_SIZE);

interface WidgetImageProps {
  feature: WidgetFeature;
  dataHook?: string;
  imageClassName?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
}

export const WidgetImage: React.FC<WidgetImageProps> = ({ feature, dataHook, imageClassName, onLoad, onLoadStart }) => (
  <Picture
    imagePath={feature.imagePath}
    sourceImageSize={IMAGE_SIZE}
    breakpoints={BREAKPOINTS}
    alt={feature.title}
    dataHook={dataHook}
    imageClassName={imageClassName}
    onLoad={onLoad}
    onLoadStart={onLoadStart}
    filters={WIDGET_IMAGE_FILTERS}
    imageTypes={WIDGET_IMAGE_TYPES}
  />
);
